var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.65 35V24.499h2.958L30 20.88h-3.35l.005-1.811c0-.944.091-1.45 1.475-1.45h1.85V14h-2.96c-3.554 0-4.805 1.755-4.805 4.708v2.172H20v3.62h2.215V35h4.435z"
  })));
}
export default SvgFacebookIcon;